/// web_ui/src/context/useUserSession.ts
import { useContext } from "react";
import { UserSessionContext, UserSessionContextType } from "./UserSessionContext";

// Custom hook to access the UserSessionContext
export const useUserSession = (): UserSessionContextType => {
  return useContext(UserSessionContext);
};
